module.exports = __webpack_public_path__ + "img/stackslash-process-4-mobile.bfb23c0f.jpg";